import React from "react";
import {ResultsPager} from "../../../../Components/Grid";
import {LoanLibraryCatalogResultsRow} from "./LoanLibraryCatalogResultsRow";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";

interface LoanLibrarySearchResultsViewProps {
    catalogResources: Record<string, any>[];
    catalogSearchCriteria: Record<string, any>;
    canManageCatalog: boolean;
    handleAddToQueue: (id: string) => void;
    handleEdit: (id: string) => void;
    handleSetSearchCriteria: (criteria: Record<string, any>) => void;
    totalRecords: number;
}

export const LoanLibrarySearchResultsView = ({
                                                 catalogResources,
                                                 catalogSearchCriteria,
                                                 canManageCatalog,
                                                 handleAddToQueue,
                                                 handleEdit,
                                                 handleSetSearchCriteria,
                                                 totalRecords,
                                             }: LoanLibrarySearchResultsViewProps) => {

    const handleFirstClick = () => {
        const criteria = {...catalogSearchCriteria, loadSearchResults: true} as Record<string, any>;
        criteria.First();
        handleSetSearchCriteria(criteria);
    };

    const handlePreviousClick = () => {
        const criteria = {...catalogSearchCriteria, loadSearchResults: true} as Record<string, any>;
        criteria.Previous();
        handleSetSearchCriteria(criteria);
    };

    const handleNextClick = () => {
        const criteria = {...catalogSearchCriteria, loadSearchResults: true} as Record<string, any>;
        criteria.Next();
        handleSetSearchCriteria(criteria);
    };

    const handleLastClick = () => {
        const criteria = {...catalogSearchCriteria, loadSearchResults: true} as Record<string, any>;
        criteria.Last(totalRecords);
        handleSetSearchCriteria(criteria);
    };

    const pager = (isSecondaryPager: boolean) => (
        <ResultsPager
            handleFirstClick={handleFirstClick}
            handlePreviousClick={handlePreviousClick}
            handleNextClick={handleNextClick}
            handleLastClick={handleLastClick}
            isSecondaryPager={isSecondaryPager}
            totalRecords={totalRecords}
            recordsPerPage={catalogSearchCriteria.recordsPerPage}
            currentPage={catalogSearchCriteria.page}
            disabled={false}
        />
    );

    const noResults = isArrayNullOrEmpty(catalogResources);

    return (
        <>
            {pager(false)}
            {
                !noResults &&
                catalogResources.map((catalogResource: Record<string, any>) => {
                    return (
                        <LoanLibraryCatalogResultsRow
                            key={catalogResource.loanLibraryCatalogId}
                            catalogResource={catalogResource}
                            canManageCatalog={canManageCatalog}
                            handleAddToQueue={handleAddToQueue}
                            handleEdit={handleEdit}
                        />
                    );
                })
            }
            {
                noResults && (
                    <div className="text-center" data-testid="no-results-row">
                        No results found.
                    </div>
                )}
            {pager(true)}
        </>
    );
};
